(() => {
  const initialize = root => {
    if (root.dataset.premiumInitialized) return;
    root.dataset.premiumInitialized = 'true';
    let config;
    try { config = JSON.parse(root.querySelector('[data-pilot-config]')?.textContent || '{}'); } catch { return; }
    const strings = config.strings || {};
    const form = document.getElementById(root.dataset.formId);
    const sticky = root.querySelector('[data-sticky-buy]');
    const stickyPlan = sticky?.querySelector('[data-sticky-plan]');
    const syncStickyPlan = () => {
      if (!stickyPlan) return;
      const label = form?.querySelector('[data-selling-plan]')?.selectedOptions[0]?.dataset.planLabel || '';
      stickyPlan.textContent = label;
      stickyPlan.hidden = !label;
    };
    const zoom = root.querySelector('[data-zoom-image]');
    const imageDialog = root.querySelector('#ap-image-dialog');
    const activeImage = () => root.querySelector('.ap-media-panel:not([hidden]) img') || root.querySelector('[data-main-image]');
    const showImage = (src, alt) => { if (!src || !zoom || !imageDialog) return; zoom.src = src; zoom.alt = alt || ''; imageDialog.showModal(); };
    const activate = button => root.querySelectorAll('[data-gallery-src],[data-gallery-media]').forEach(other => {
      other.classList.toggle('is-active', other === button);
      other.setAttribute('aria-pressed', String(other === button));
    });
    root.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => {
      const main = activeImage();
      if (!main) return;
      main.removeAttribute('srcset');
      main.src = button.dataset.gallerySrc;
      main.alt = button.dataset.galleryAlt || '';
      main.classList.toggle('is-label', /thorne-label|thorne-use/.test(button.dataset.gallerySrc));
      const stageLabel = root.querySelector('[data-stage-label]');
      if (stageLabel) stageLabel.textContent = button.dataset.galleryLabel;
      activate(button);
    }));
    root.querySelectorAll('[data-gallery-media]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-media-panel]').forEach(panel => {
        const selected = panel.dataset.mediaPanel === button.dataset.galleryMedia;
        panel.hidden = !selected;
        if (!selected) {
          panel.querySelectorAll('video').forEach(video => video.pause());
          panel.querySelectorAll('iframe').forEach(frame => { const src = frame.src; frame.src = src; });
        }
        if (selected) { const control = root.querySelector('[data-open-dialog="ap-image-dialog"]'); if (control) control.hidden = panel.dataset.mediaType !== 'image'; }
      });
      activate(button);
    }));
    root.querySelectorAll('[data-open-dialog]').forEach(button => button.addEventListener('click', () => {
      if (button.dataset.openDialog === 'ap-image-dialog') { const image = activeImage(); if (image) showImage(image.currentSrc || image.src, image.alt); }
      else root.querySelector(`#${button.dataset.openDialog}`)?.showModal();
    }));
    root.querySelector('[data-label-dialog]')?.addEventListener('click', () => showImage(config.labelImage, root.querySelector('[data-gallery-src*="thorne-label"]')?.dataset.galleryAlt));
    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.querySelector('[data-close-dialog]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    });
    root.querySelectorAll('[data-option-value]').forEach(select => select.addEventListener('change', () => {
      const url = new URL(location.href);
      const target = select.selectedOptions[0]?.dataset.productUrl;
      if (target) { const candidate = new URL(target, location.origin); if (candidate.origin === location.origin) url.pathname = candidate.pathname; }
      url.searchParams.delete('variant');
      url.searchParams.delete('selling_plan');
      url.searchParams.set('option_values', [...root.querySelectorAll('[data-option-value]')].map(option => option.value).join(','));
      root.setAttribute('aria-busy', 'true');
      root.querySelectorAll('[data-add-button]').forEach(button => { button.disabled = true; });
      if (sticky) sticky.hidden = true;
      location.assign(url.href);
    }));
    root.querySelector('[data-selling-plan]')?.addEventListener('change', event => {
      const price = event.target.selectedOptions[0]?.dataset.price;
      if (price) root.querySelectorAll('[data-price]').forEach(node => { node.textContent = price; });
      syncStickyPlan();
      const url = new URL(location.href);
      if (event.target.value) url.searchParams.set('selling_plan', event.target.value); else url.searchParams.delete('selling_plan');
      history.replaceState({}, '', url);
    });
    root.querySelector('[data-premium-waitlist]')?.addEventListener('submit', event => {
      event.preventDefault();
      if (window.ApothecaWaitlist?.submit) window.ApothecaWaitlist.submit(event);
    });
    if (form) {
      const quantity = form.querySelector('[name="quantity"]');
      const stickyQuantity = sticky?.querySelector('[data-sticky-quantity]');
      const stickyStatus = sticky?.querySelector('[data-sticky-status]');
      const syncStickyQuantity = () => { if (stickyQuantity && quantity) stickyQuantity.textContent = quantity.value; };
      const normalizeQuantity = () => {
        if (!quantity) return;
        const min = Number(quantity.min) || 1;
        const step = Number(quantity.step) || 1;
        const max = quantity.max ? Number(quantity.max) : Infinity;
        const requested = Number(quantity.value) || min;
        const stepped = min + Math.max(0, Math.floor((requested - min) / step)) * step;
        quantity.value = Math.min(max, stepped);
        syncStickyQuantity();
      };
      root.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
        if (!quantity) return;
        quantity.value = (Number(quantity.value) || Number(quantity.min) || 1) + Number(button.dataset.quantityStep) * (Number(quantity.step) || 1);
        normalizeQuantity();
      }));
      quantity?.addEventListener('change', normalizeQuantity);
      quantity?.addEventListener('input', syncStickyQuantity);
      syncStickyPlan();
      syncStickyQuantity();
      let submitting = false;
      const selected = config.selectedVariant;
      const setButtons = (label, disabled) => root.querySelectorAll('[data-add-button]').forEach(button => {
        button.disabled = disabled;
        const text = button.querySelector('[data-add-label]'); if (text) text.textContent = label;
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (submitting || !config.purchaseEnabled || !selected?.available || Number(selected.price) <= 0 || !form.reportValidity()) return;
        normalizeQuantity();
        const body = new FormData(form);
        if (String(body.get('id')) !== String(selected.id) || (config.requiresSellingPlan && !body.get('selling_plan'))) return;
        submitting = true;
        setButtons(strings.adding, true);
        const status = root.querySelector('[data-cart-status]');
        status.replaceChildren();
        if (stickyStatus) { stickyStatus.replaceChildren(); stickyStatus.hidden = true; }
        try {
          const response = await fetch(config.addUrl, { method: 'POST', body, headers: { Accept: 'application/json' } });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : strings.error);
          status.textContent = strings.added;
          const link = document.createElement('a'); link.href = config.cartUrl; link.textContent = strings.viewCart; status.append(link);
          if (stickyStatus) {
            stickyStatus.textContent = strings.added;
            const stickyLink = document.createElement('a'); stickyLink.href = config.cartUrl; stickyLink.textContent = strings.viewCart; stickyStatus.append(stickyLink);
            stickyStatus.hidden = false;
          }
          try {
            const cartResponse = await fetch(`${config.cartUrl}.js`, { headers: { Accept: 'application/json' } });
            if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('.cart-count').forEach(node => { node.textContent = cart.item_count; }); document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } })); }
          } catch {}
        } catch (error) {
          const message = error.message || strings.error;
          status.textContent = message;
          if (stickyStatus) { stickyStatus.textContent = message; stickyStatus.hidden = false; }
        }
        finally { submitting = false; setButtons(strings.add, !config.purchaseEnabled); }
      });
      const primary = form.querySelector('[data-add-button]');
      if (sticky && primary) {
        let frame = 0;
        const listeners = new AbortController();
        const observers = [];
        const updateSticky = () => {
          frame = 0;
          const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
          const mobileEditing = editing && window.matchMedia('(max-width: 749px)').matches;
          const keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * 0.75;
          const modal = document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])');
          const canShow = config.purchaseEnabled && !root.hasAttribute('aria-busy') && primary.getBoundingClientRect().bottom <= 0 && !modal && !mobileEditing && !keyboard;
          if (!canShow && sticky.contains(document.activeElement) && primary.getBoundingClientRect().bottom > 0) primary.focus({ preventScroll: true });
          sticky.hidden = !canShow;
        };
        const scheduleSticky = () => { if (!frame) frame = requestAnimationFrame(updateSticky); };
        window.addEventListener('scroll', scheduleSticky, { passive: true, signal: listeners.signal });
        window.addEventListener('resize', scheduleSticky, { signal: listeners.signal });
        window.visualViewport?.addEventListener('resize', scheduleSticky, { signal: listeners.signal });
        document.addEventListener('focusin', scheduleSticky, { signal: listeners.signal });
        document.addEventListener('focusout', scheduleSticky, { signal: listeners.signal });
        root.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('close', scheduleSticky, { signal: listeners.signal });
          const observer = new MutationObserver(scheduleSticky);
          observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
          observers.push(observer);
        });
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(scheduleSticky, { threshold: 0 });
          observer.observe(primary);
          observers.push(observer);
        }
        const cleanupSticky = event => {
          if (!event.target.contains(root)) return;
          listeners.abort();
          observers.forEach(observer => observer.disconnect());
          if (frame) cancelAnimationFrame(frame);
          document.removeEventListener('shopify:section:unload', cleanupSticky);
        };
        document.addEventListener('shopify:section:unload', cleanupSticky);
        scheduleSticky();
      }
    }
    const node = (tag, className, text) => { const element = document.createElement(tag); if (className) element.className = className; if (text !== undefined) element.textContent = text; return element; };
    root.querySelectorAll('.apotheca-label-text').forEach(text => {
      const lines = text.innerHTML.split(/<br\s*\/?\s*>/i).map(line => new DOMParser().parseFromString(line, 'text/html').body.textContent.trim()).filter(Boolean);
      const rows = lines.map(line => line.match(/^(.+?)\s*\.{3}\s*(.+)$/)).filter(Boolean);
      if (rows.length < 5) return;
      const table = node('table', 'ap-label-table'); table.append(node('caption', 'ap-sr-only', strings.supplementFacts));
      const tbody = node('tbody', '');
      rows.forEach(row => { const tr = node('tr', ''); tr.append(node('td', '', row[1]), node('td', '', row[2])); tbody.append(tr); });
      table.append(tbody);
      const extra = lines.filter(line => !/^(.+?)\s*\.{3}\s*(.+)$/.test(line));
      const headerIndex = extra.findIndex(line => /^Other Ingredients/i.test(line));
      const intro = headerIndex < 0 ? extra : extra.slice(0, headerIndex);
      const remainder = headerIndex < 0 ? [] : extra.slice(headerIndex);
      const container = node('div', ''); container.append(node('p', 'ap-caption', intro.join(' ')), table);
      if (remainder.length) container.append(node('p', 'ap-label-extra', remainder.join('\n')));
      text.replaceWith(container);
    });
  };
  document.querySelectorAll('.ap-premium').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ap-premium').forEach(initialize));
})();
